export default noApplyClick

/** @ngInject */
function noApplyClick($parse) {
    return ({
        compile($element, attr) {
            const fn = $parse(attr.noApplyClick)
            return (scope, element, attr) => element.on('click', (event) => fn(scope, { $event: event, $element: element }))
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/no-apply-click/directive.js